import React from "react";
import { agentMeta } from "@/lib/agents";
import { cn } from "@/lib/utils";

/** Monogram chip for an agent persona (no photos, no robots). */
export const AgentChip = ({ agentId, persona, size = "sm", className = "", testId }) => {
  const meta = agentMeta(agentId);
  const label = persona || meta.persona;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-md border px-1.5 py-0.5 text-xs font-medium", meta.classes, className)} data-testid={testId || `agent-chip-${agentId}`}>
      <span className={cn("flex items-center justify-center rounded-sm bg-white/70 font-heading font-semibold", size === "sm" ? "h-4 w-5 text-[9px]" : "h-5 w-6 text-[10px]")} aria-hidden="true">{meta.initials}</span>
      <span className="truncate">{label}</span>
    </span>
  );
};
